import { render, staticRenderFns } from "./BlocksForm.vue?vue&type=template&id=6eff53d2&scoped=true"
import script from "./BlocksForm.vue?vue&type=script&lang=js"
export * from "./BlocksForm.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./BlocksForm.vue?vue&type=style&index=1&id=6eff53d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eff53d2",
  null
  
)

export default component.exports